import { ENV as base } from './environment.base';
import { InstallmentType } from '@ux/entities/installment-types';

const env = {
  ...base,
  urlPath: 'https://travel.rappi.com.br',
  webview_auth: 'prodbr',
  production: true,
  defaultLocale: 'pt-BR',
  localeCMS: 'br',
  language: 'PT',
  branchcode: '5',
  domain_checkout: 'rappi.com.br',
  desktop_checkout: 'https://www.rappi.com.br/checkout',
  web_login: 'https://www.rappi.com.br/login?url_redirect={redirect}',
  user_service: 'rappibr',
  currency_precision: 0,
  footer_operated_by: 'Operado por RAPPI AGÊNCIA DE VIAGENS E TURISMO LTDA. SP-CEP: 04530-000 - CNPJ: 35.506.356/0001-86.',
  proxy_images: 'https://services.rappi.com.br/api/ms/travel-imageproxy',
  rappipro_link: 'https://pro.rappi.com/brasil',
  covid_location_restrict: [],
  travel_city_limit: 10,
  validate_search: {
    ...base.validate_search,
    flighs: {
      ...base.validate_search.flighs,
      calendar_days_limit: 2,
      international_dates: {
        minDate: '2021/03/10',
        maxDate: '2021/03/11'
      },
      national_dates: {
        minDate: '2021/03/10',
        maxDate: '2021/03/11'
      },
    },
    hotels: {
      ...base.validate_search.buses,
      calendar_days_limit: 2,
      open_search: true,
      international_dates: {
        minDate: '',
        maxDate: ''
      },
      national_dates: {
        minDate: '',
        maxDate: ''
      }
    },
    buses: {
      calendar_days_limit: 2,
      ...base.validate_search.buses
    }
  },
  countryModules: {
    ...base.countryModules,
    calendar_days_limit: 2,
    booking: {
      ...base.countryModules.booking,
      call_support: true,
      exchange_rate: {
        ...base.countryModules.booking.exchange_rate,
        enabled: false,
        currency_to: null,
        currency_to_name: null,
        show_currency_sufix: false
      },
      go_to_pay_button: {
        ...base.countryModules.booking.go_to_pay_button,
        enabled_price_info: true
      }
    },
    header: {
      ...base.countryModules.header,
      show_disabled_products: false,
    },
    installments: {
      partner_type: InstallmentType.NONE,
    },
    user_history: {
      exchange: false,
      can_do_payment: true,
      disabled_airlines_exchange: [],
      seatMap: false
    },
    cancellation: {
      ...base.countryModules.cancellation,
      hotel_enabled: false,
      flight_enabled: false,
      disabled_by_airlines: ['JA', 'JZ', 'WJ']
    },
    show_select_class: false,
    airlines_local_policies_info: {
      ...base.countryModules.airlines_local_policies_info,
      'LA': 'https://www.latamairlines.com/br/pt'
    },
    banner_results: {
      ...base.countryModules.banner_results,
      banner_enabled_flighs: true,
      banner_enabled_hotels: true,
      banner_enabled_autos: true,
      banner_enabled_air_packages: true,
      banner_enabled_buses: false,
      banner_flights_available: 'RAPPI_CARD',
      banner_hotels_available: 'RAPPI_CARD',
      banner_autos_available: 'RAPPI_CARD',
      banner_air_packages_available: 'RAPPI_CARD',
      banner_buses_available: 'RAPPI_CARD',
      cashback: {
        flights: { total: 0, card: 0, credits: 0, references: [] },
        hotels: { total: 0, card: 0, credits: 0, references: [] },
        autos: { total: 0, card: 0, credits: 0, references: [] },
        air_packages: { total: 0, card: 0, credits: 0, references: [] },
        buses: { total: 0, card: 0, credits: 0, references: [] },
      }
    }
  },
  countryInfo: {
    ...base.countryInfo,
    name: 'Brasil',
    phone_prefix: '+55',
    support_phone: 1152423450,
    whatsapp_help_message: 'Olá! Preciso de ajuda com o itinerário',
    iso_code: 'BR',
    currency_code: 'BRL',
    icon: 'https://images.rappi.com/web/countries-flags/br.webp',
    locale: 'pt-BR',
    show_currency_sufix: false,
    twitter: 'https://twitter.com/rappibrasil?lang=pt',
    instagram: 'https://www.instagram.com/rappibrasil/?hl=pt',
    facebook: 'https://www.facebook.com/RappiBrasil/',
    country_id: 5,
    minutes_to_restart_searches: 25,
    displayTUA: false,
    tzIdentifier: 'America/Sao_Paulo'
  },
  default_address: {
    ...base.default_address,
    address: 'R. Ten. Negrão, 90 - Itaim Bibi, [São Paulo] - SP, 04530-030, Brasil',
    lat: -22.0000000,
    lng: -49.0000000,
  },
  header_redirect: {
    ...base.header_redirect,
    link: 'https://www.rappi.com.br/',
    title: 'rappi.com.br'
  },
  footer_links: {
    ...base.footer_links,
    terms_rappi: 'https://legal.rappi.com.co/brazil/termos-e-condicoes-app-soy-shopper/',
    restaurants: 'https://www.rappi.com.br/restaurantes',
    markets: 'https://www.rappi.com.br/aliados/tipo/market',
    courier: 'https://www.rappi.com.br/courier-hours',
    // eslint-disable-next-line max-len
    data_treatment_rappi: 'https://legal.rappi.com/brazil/aviso-de-privacidade-e-politicas-de-uso-das-informacao-utilizadas-pela-rappi/',
  },
  api: {
    ...base.api,
    services: 'https://services.rappi.com.br',
    travel_flight_content: 'https://services.grability.rappi.com',
    server: 'https://v2.grability.rappi.com',
    netactica: 'https://reservas.servicesnet.agency/netcoreapi',
    images: 'https://reservas.servicesnet.agency/Images',
    search: 'https://services.rappi.com',
    travel_data_info: 'https://services.rappi.com.br/api/ms/travel-data-info',
    travel_order_billing: 'https://services.rappi.com.br/api/ms/travel-order-billing',
    travel_alerts: 'https://services.rappi.com.br/api/ms/travel-alerts',
    travel_static_content: 'https://services.rappi.com.br/api/travel-static-content-ms',
    travel_cms: 'https://services.rappi.com.br/api/travelcms',
    static_search_hotel_autocomplete: 'https://services.grability.rappi.com/api/travel-hotel-search',
    lifemiles_integration: 'https://services.rappi.com.br/api/ms/loyalty-notification'
  },
  booking_options: {
    ...base.booking_options,
  },
  store_configuration: {
    ...base.store_configuration,
    STORE_ID: 900125490,
    SUPPORT_LINK: 'gbrappi://com.grability.rappi?goto=chat&chat_type=non_live_chat&chat_key=HC_NO_RELATED_TO_ORDERS',
    WHATSAPP_SUPPORT_LINK: 'https://wa.me/551142002984',
    WHATSAPP_SUPPORT_APP_LINK: 'whatsapp://send?phone=551142002984',
  },
  chubb_insured_sum_age: true,
  animation: {
    url: '/assets/libs/ngx-lottie/BR/animate-cashback.json',
    options: {
      width: '85vw',
      height: 'auto',
      maxWidth: '85vw',
      maxHeight: 'auto',
      marginLeft: '0px'
    }
  },
  chubb_terms_pdf: 'https://rappi-images-upload-co.s3.amazonaws.com/web/travel/Chubb/PDF/CHUBB-Terms-of-service-BR.pdf'
};

export const environment = env;
